import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type WeatherConditionDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const WeatherConditionDetails = ({
  control,
}: WeatherConditionDetailsProps) => {
  const { errors } = useFormState({
    control,
  });

  const { general: { weatherAtStart, weatherAtEnd } = {} } = useWatch({
    control,
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <ThunderstormIcon fontSize="inherit" />
            <span>&nbsp;Weather condition details</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Start:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.weatherAtStart
                ? 'error'
                : isNil(weatherAtStart)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {isNil(weatherAtStart) ? '—' : weatherAtStart}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            End:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              errors.general?.weatherAtEnd
                ? 'error'
                : isNil(weatherAtEnd)
                  ? 'textDisabled'
                  : 'textPrimary'
            }>
            {isNil(weatherAtEnd) ? '—' : weatherAtEnd}
          </Typography>
        </Grid>
        <Divider />
      </Stack>
    </Box>
  );
};
